import React, { useState } from "react";
import ReactDom from "react-dom";
import Input from "../UIResuableComponents/CreateForm/Input";
import Button from "../UIResuableComponents/Button";
import { MdOutlineCancel } from "react-icons/md";

const firstOptionData = [
  { value: "option1", label: "item1", type: "optionOne" },
  { value: "option2", label: "item2", type: "optionOne" },
];
const secondOptionData = [
  { value: "option1", label: "Report1", type: "optionTwo" },
  { value: "option2", label: "Report2", type: "optionTwo" },
];

function ComparePopUp(props) {
  const [optionsValue, setOptionsValue] = useState({
    optionOne: "",
    optionTwo: "",
  });

  const [optionFirst, setOptionFirst] = useState(firstOptionData);
  const [optionSecond, setOptionSecond] = useState(secondOptionData);



  const onSetInputValue = (name, value) => {
    
  
    const newOptionValue = { ...optionsValue };
    newOptionValue[name] = value;
    setOptionsValue(newOptionValue);
    if (value.type === "optionOne") {
      const filteredOptions = secondOptionData.filter(
        (opt) => opt.value !== value.value
      );

      setOptionSecond(filteredOptions);
    }
    if (value.type === "optionTwo") {
      const filteredOptions = firstOptionData.filter(
        (opt) => opt.value !== value.value
      );
      setOptionFirst(filteredOptions);
    }
  };
// To reset the fields in dropdown compare graph in Report
  const resetCompareHandler=(e)=>{
    e.preventDefault()
    setOptionFirst(firstOptionData);
    setOptionSecond(secondOptionData);
    setOptionsValue({
      optionOne: "",
      optionTwo: "",
    })
  }

  console.log(optionSecond);
  const popup = (
    <div className=" px-4 bg-bgwhite md:w-[40%] fixed top-[30%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-50 rounded">
      <div
        onClick={props.closeComparePopUpToggle}
        className="absolute top-[3%] right-[5%] text-2xl cursor-pointer text-btnbgcolor"
      >
        <MdOutlineCancel />
      </div>
      <h1 className="font-bold text-lg mt-5 text-center">
        Choose Option to Compare
      </h1>
      <form className="flex flex-col py-8 items-center">
        <div className="flex justify-center">
          <Input
            valueLabel={"optionOne"}
            onInputChangeHandler={onSetInputValue}
            type={"select"}
            Name={"Select Option one"}
            value={optionsValue.optionOne}
            placeholder={"Select option"}
            options={optionFirst}
            CustomInputStyle={"!mr-4"}
            // errorMsg={props.ErrorData[item.valueLabel]}
          />
          <Input
            valueLabel={"optionTwo"}
            onInputChangeHandler={onSetInputValue}
            type={"select"}
            Name={"Select Option Two"}
            value={optionsValue.optionTwo}
            placeholder={"Select option"}
            options={optionSecond}
            // CustomInputStyle={item.CustomInputStyle}
            // errorMsg={props.ErrorData[item.valueLabel]}
          />
        </div>
        <div className="w-full text-center">
        <Button
          onClickHandler={resetCompareHandler}
          btnName="Reset"
          btnStyle="bg-textgreen text-bgwhite !text-xs !py-3 !text-xs font-bold w-[30%] mr-5"
        />
        <Button
          btnName="Select"
          btnStyle="bg-btnbgcolor text-bgwhite !text-xs !py-3 !text-xs font-bold w-[30%] "
        />
        </div>
      </form>
    </div>
  );
  return ReactDom.createPortal(popup, document.querySelector("#over-lay"));
}

export default ComparePopUp;
